export const ADD_BANK_DETAILS_STARTED = 'ADD_BANK_DETAILS_STARTED';
export const ADD_BANK_DETAILS_COMPLETED = 'ADD_BANK_DETAILS_COMPLETED';
export const ADD_BANK_DETAILS_ERROR = 'ADD_BANK_DETAILS_ERROR';

export const ADD_PROFILE_DETAILS_STARTED = 'ADD_PROFILE_DETAILS_STARTED';
export const ADD_PROFILE_DETAILS_COMPLETED = 'ADD_PROFILE_DETAILS_COMPLETED';
export const ADD_PROFILE_DETAILS_ERROR = 'ADD_PROFILE_DETAILS_ERROR';

export const UPDATE_PROFILE_DETAILS_STARTED = 'UPDATE_PROFILE_DETAILS_STARTED';
export const UPDATE_PROFILE_DETAILS_COMPLETED = 'UPDATE_PROFILE_DETAILS_COMPLETED';
export const UPDATE_PROFILE_DETAILS_ERROR = 'UPDATE_PROFILE_DETAILS_ERROR';

export const FETCH_PROFILE_DETAILS_STARTED = 'FETCH_PROFILE_DETAILS_STARTED';
export const FETCH_PROFILE_DETAILS_COMPLETED = 'FETCH_PROFILE_DETAILS_COMPLETED';
export const FETCH_PROFILE_DETAILS_ERROR = 'FETCH_PROFILE_DETAILS_ERROR';

export const EDIT_PROFILE_DETAILS_STARTED = 'EDIT_PROFILE_DETAILS_STARTED';
export const EDIT_PROFILE_DETAILS_COMPLETED = 'EDIT_PROFILE_DETAILS_COMPLETED';
export const EDIT_PROFILE_DETAILS_ERROR = 'EDIT_PROFILE_DETAILS_ERROR';



// WEBPACK FOOTER //
// ./src/redux/actionTypes/profileActionTypes.js